import React, { Component } from 'react';
import moment from 'moment';
import {
  StyledSearchByDate,
  StyledDateWrapper,
  StyledDate,
  StyledMonthDay,
  StyledDay,
  StyledMonth,
  StyledWeekDay,
  StyledButtondate,
  StyledIconArrow,
  StyledForm,
  StyledButtonPlus,
  StyledWrapperDate,
  StyledDropdownDay,
  StyledDropdownMonth,
  StyledDropdownYear
} from './style';

import { ArrowLeft, Back } from '../../../../assets/images/index';
import { getWeekday } from '../../../utils/dates';

const YEARS_INDEX = 20;
const YEAR_SELECTOR = 'YEAR_SELECTOR';
const MONTH_SELECTOR = 'MONTH_SELECTOR';
const DAY_SELECTOR = 'DAY_SELECTOR';

class SearchByDate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      daySelect: this.formatDate(moment().format('D')),
      monthSelect: this.formatDate(moment().format('M')),
      yearSelect: this.formatDate(moment().format('YYYY'))
    };

    const { fullDay, isAudiences } = this.props;

    if (isAudiences) {
      this.state = {
        active: false,
        daySelect: this.formatDate(
          moment()
            .endOf('month')
            .format('D')
        ),
        monthSelect: this.formatDate(moment().format('M')),
        yearSelect: this.formatDate(moment().format('YYYY'))
      };
      if (
        fullDay !== null &&
        fullDay !== undefined &&
        fullDay?.day !== undefined &&
        fullDay?.day !== null
      ) {
        const { day } = fullDay;
        const date = new Date(day);
        const dia = date.getDate();
        const mes = date.getMonth() + 1;
        const año = date.getFullYear();

        this.state = {
          active: false,
          daySelect: this.formatDate(dia),
          monthSelect: this.formatDate(mes),
          yearSelect: this.formatDate(año)
        };
      }
    }
    this.toggleSearch = this.toggleSearch.bind(this);
  }

  formatDate = dat => {
    const datNum = parseInt(dat, 10);
    return datNum < 10 ? `0${datNum}` : datNum.toString();
  };

  formatYear = year => Number(moment().format('YYYY')) - year;

  dateChange = (item, value) => {
    const { daySelect, monthSelect, yearSelect } = this.state;
    let maxDays;
    switch (item) {
      case DAY_SELECTOR:
        this.setState({
          daySelect: this.formatDate(value.value + 1)
        });
        break;
      case MONTH_SELECTOR:
        maxDays = moment(
          `${yearSelect}-${this.formatDate(value.value + 1)}`,
          'YYYY-MM'
        ).daysInMonth();
        if (maxDays < daySelect) {
          this.setState({
            daySelect: this.formatDate(maxDays),
            monthSelect: this.formatDate(value.value + 1)
          });
        } else {
          this.setState({ monthSelect: this.formatDate(value.value + 1) });
        }
        break;

      case YEAR_SELECTOR:
        maxDays = moment(
          `${this.formatYear(value.value)}-${monthSelect}`,
          'YYYY-MM'
        ).daysInMonth();
        if (maxDays < daySelect) {
          this.setState({
            daySelect: this.formatDate(maxDays),
            yearSelect: this.formatYear(value.value)
          });
        } else {
          this.setState({
            yearSelect: this.formatYear(value.value)
          });
        }
        break;
      default:
        break;
    }
  };

  toggleSearch() {
    const { active } = this.state;
    this.setState({
      active: !active
    });
  }

  render() {
    const { onClick } = this.props;

    const { active, daySelect, monthSelect, yearSelect } = this.state;
    const dateSelected = moment(
      `${yearSelect}-${this.formatDate(monthSelect)}-${this.formatDate(
        daySelect
      )}`
    );
    const yearCurrent = new Date().getFullYear();
    const yearsList = Array.from(new Array(YEARS_INDEX), (v, i) => ({
      value: i,
      text: (yearCurrent - i).toString()
    }));

    const monthsBase = moment.months();
    const monthsList = monthsBase.map((v, i) => ({
      value: i,
      text: v
    }));
    const daysBase = dateSelected.daysInMonth();

    const daysList = Array.from(new Array(daysBase), (v, i) => ({
      value: i,
      text: this.formatDate(i + 1)
    }));
    return (
      <StyledSearchByDate>
        <StyledDateWrapper>
          <StyledDate>
            <StyledDay>{daySelect}</StyledDay>
            <StyledMonthDay>
              <StyledMonth>
                {moment()
                  .month(this.formatDate(monthSelect - 1))
                  .format('MMMM')}
              </StyledMonth>
              <StyledWeekDay>{getWeekday(dateSelected.day())}</StyledWeekDay>
            </StyledMonthDay>
          </StyledDate>
          <StyledButtondate transparent onClick={this.toggleSearch}>
            Seleccionar fecha
            <StyledIconArrow
              svg={ArrowLeft}
              size="s"
              color="dark"
              activeForm={active}
            />
          </StyledButtondate>
        </StyledDateWrapper>
        <StyledForm activeForm={active}>
          <StyledWrapperDate>
            <StyledDropdownDay
              list={daysList}
              label={this.formatDate(daySelect)}
              onSelect={e => this.dateChange(DAY_SELECTOR, e)}
            />
            <StyledDropdownMonth
              list={monthsList}
              label={moment()
                .month(this.formatDate(monthSelect - 1))
                .format('MMMM')}
              onSelect={e => this.dateChange(MONTH_SELECTOR, e)}
            />
            <StyledDropdownYear
              list={yearsList}
              label={this.formatDate(yearSelect)}
              onSelect={e => this.dateChange(YEAR_SELECTOR, e)}
            />
          </StyledWrapperDate>
          <StyledButtonPlus
            dark
            svg={Back}
            onClick={onClick(dateSelected.format('YYYY-MM-DD'))}
          />
        </StyledForm>
      </StyledSearchByDate>
    );
  }
}

export default SearchByDate;
